"use strict";

import axios from "axios";
import router from "../router";
import store from "../store";

export default {
	checkin: async (eventId, scheduleId, externalId) => {
		const req = {
			code: externalId,
	        type: "attendee",
	        date: new Date().toISOString()
		};
		let res = null; 
		
		try{
			res = await axios({
				method: "put",
				url: store.getters.apiBase + "/events/" + eventId +  "/schedule/" + scheduleId + "/guests",
				headers: {
					"Content-Type": "application/json",
					Authorization: store.getters.accessToken,
					account_id: store.getters.accountId
				},
				data: req
			});
			
			console.debug("res", res)
			router.push({name: "guestsList", params: {event_id: eventId, schedule_id: scheduleId, type: "attendee"}});
		} catch(err) {
			console.error(err);
			router.push({name: "error", params: {message: err}});
		}
	},
	
	removeCheckin: async (eventId, scheduleId, externalId) => {
		const req = {
			code: externalId,
	        type: "attendee",
	        date: new Date().toISOString()
		};
		let res = null; 
		
		try{
			res = await axios({
				method: "delete",
				url: store.getters.apiBase + "/events/" + eventId +  "/schedule/" + scheduleId + "/guests",
				headers: {
					"Content-Type": "application/json",
					Authorization: store.getters.accessToken,
					account_id: store.getters.accountId
				},
				params: req
			});
			
			console.debug("res", res)
			router.push({name: "guestsList", params: {event_id: eventId, schedule_id: scheduleId, type: "attendee"}});
		} catch(err) {
			console.error(err);
			router.push({name: "error", params: {message: err}});
		}
	}
}